import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import ColumnFilterSlice from 'redux-setup/slices/ColumnFilterSlice';
import userReducer from 'redux-setup/slices/userSlice';
import pathReducer from 'redux-setup/slices/pageConfigSlice';
import permissionReducer from 'redux-setup/slices/permissionSlice';
import invitationSlice from 'redux-setup/slices/InvitationSlice';
import themeSlice from './slices/themeSlice';
import organizationSlice from './slices/organizationSlice';
import repositoriesSlice from './slices/repositoriesSlice';
import codeSlice from './slices/codeSlice';
import stagesSlice from './slices/stageSlice';

const rootReducer = combineReducers({
  user: userReducer,
  pathConfig: pathReducer,
  permission: permissionReducer,
  invitation: invitationSlice,
  columnFilter: ColumnFilterSlice,
  theme: themeSlice,
  organization: organizationSlice,
  repositories: repositoriesSlice,
  stages: stagesSlice,
  code: codeSlice,
});

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['shopify'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat(thunk),
});

export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
